import React, { Component, Fragment } from 'react';
import { VacationContext } from 'js/components/step1/VacationContext';
import CollapsibleWrapper from 'js/components/global/collapsible/CollapsibleWrapper';
import { Input, FormGroup, Select } from 'react-nice-inputs';
// import DataService from 'js/modules/dataservice';
import ContinueButton from 'js/components/step1/ContinueButton';
import ForgotPasswordModalWrapper from 'js/components/step1/ForgotPasswordModalWrapper';
import PrivacyPolicyModalWrapper from 'js/components/step1/PrivacyPolicyModalWrapper';
import PointsOfferModalWrapper from 'js/components/step1/PointsOfferModalWrapper';
import BestPriceModalWrapper from 'js/components/global/BestPriceModalWrapper';
import ReCAPTCHA from 'react-google-recaptcha';
import WhyBook from 'js/components/step1/WhyBook';
import SubmitLoader from 'js/components/global/SubmitLoader';
import { numberWithCommas } from 'js/modules/utils';

const _internals = {
  brands: {
    s: 'Sandals',
    b: 'Beaches',
  }
};

const paramNames = Object.keys(_app.urlparams);
const params = {};

// params from QQ comming in Uppercase
paramNames.map(name => {
  params[`${name.toLowerCase()}`] = _app.urlparams[name] || '';
});

class OptionalControls extends Component {

  constructor(props) {
    super(props);

    this.ssgRef = React.createRef();
  }

  state = {
    ssg: [],
    group: [],
    wedding: [],
    subscribe: [],
    hasSSG: false,
    hasGroup: false,
    ssgCollapsed: false,
    signedIn: false,
    groupBlock: false,
  }

  componentDidMount = () => {

    if (this.props.hasSSG) {
      this.setState({ ssg: ['ssg'], hasSSG: true, ssgCollapsed: false });
    }

    if (this.props.hasGroup) {
      this.setState({ group: ['isGroup'], hasGroup: true });
    }
  }

  /* eslint-disable */
  componentDidUpdate(prevProps) {

    if (this.props.hasSSG !== prevProps.hasSSG) {

      this.props.hasSSG && this.setState({ hasSSG: this.props.hasSSG, ssg: ['ssg'] });

      this.props.hasSSG ? this.setState({ signedIn: true }) : this.setState({ signedIn: false, ssg: [], ssgCollapsed: false });
    }

    if (this.props.hasGroup !== prevProps.hasGroup) {

      this.setState({ hasGroup: this.props.hasGroup, group: ['isGroup'] });

      this.props.hasGroup ? this.setState({ groupBlock: true }) : this.setState({ group: [''] });
    }
  }
  /* eslint-enable */

  // fetchData = async() => {
  //   const dataServiceResp = await DataService.getAllInfo('/read-countries/');

  //   this.setState({ countries: dataServiceResp });
  // }

  _getBrandName = () => _internals.brands[window._app.brand];

  _calculatePoints = (points = '') => Math.round((points * 0.025) * 100) / 100;

  _handleSSG = (context, ssgLink = false) => {

    return (event, value = '') => {

      if (this.state.signedIn) {
        this.setState({ ssgCollapsed: false, ssg: [value] });
      } else {
        if (!ssgLink) {
          this.setState({ ssgCollapsed: !(this.state.ssgCollapsed), ssg: [value] });
        } else if (ssgLink) {
          this.setState({ ssgCollapsed: true, ssg: ['ssg'] });
        }
      }

      const { showRecaptcha } = context.state;

      // this.setState({ ssg: [value] });
      if (ssgLink) {
        this._scrollToSSG();
        context.validationRules.username = ['required', 'ssgUsername'];
        context.validationRules.password = ['required'];

        if (showRecaptcha) {
          context.validationRules.recaptchaToken = ['required'];
        }
      } else {
        if (showRecaptcha) {
          context.toggleRequired(['username', 'password', 'recaptchaToken'])();
        } else {
          context.toggleRequired(['username', 'password'])();
        }
      }
    };
  };

  _scrollToSSG = () => {
    const element = this.ssgRef.current;

    element.scrollIntoView({ behavior: 'smooth' });
  }

  _isPromoInUrl = () => {

    if (params.hasOwnProperty('prpromocode') &&
      params.prpromocode.toUpperCase() === 'LTT005D') {
      return true;
    }

    return false;
  }

  _getSSGCollapsibleState = () => {

    if (this.state.hasSSG && this.state.signedIn) {
      return true;
    }

    return this.state.ssgCollapsed;
  }

  _handleGroup = () => {

    return (event, value = '') => {

      this.setState({ group: [value] });
    };
  };

  _handleWedding = ({ context }) => {

    return (event, value = '') => {

      this.setState({ wedding: [value] });

      context.setInputValue(true, 'wedding');
    };
  };

  _handleSubscribe = ({ context }) => {

    return (event, value = '') => {

      this.setState({ subscribe: [value] });

      context.toggleRequired(['fname', 'email', 'country'])();
    };
  };

  render() {
    const brand = this._getBrandName();
    // THESE ARE REQUIRED FOR FETCHING DATA WHEN COLLAPSIBLEWRAPPER IS CLICKED
    // const endPoints = {
    //   getCountries: '/read-countries/',
    // };

    const ssgCheckBoxProps = {
      options: [{
        label: (<span className="label-text">I'm a Sandals Select Rewards Member. (Account Access)</span>),
        value: 'ssg',
        attrs: { disabled: this.state.signedIn }
      }],
      name: 'sandals_select_member',
      value: this.state.ssg,
      classList: ['check-alt'],
    };

    const privacyPolicy = {
      sandals: 'https://www.sandals.com/privacy-policy/',
      beaches: 'https://www.beaches.com/privacy/'
    };

    const subscriberCheckBoxProps = {
      options: [{
        label: (
          <Fragment>
            <span className="label-text">I would like to subscribe to {brand} email list.
              <a className="privacy-link" href={privacyPolicy[brand.toLowerCase()]} target="_blank" aria-label="Resort Privacy Policy">Privacy Policy</a>
            </span>
          </Fragment>
        ),
        value: 'isEmailSubscribing'
      }],
      name: 'sandals_email_subscribe',
      value: this.state.subscribe,
      classList: ['check-alt'],
    };

    return (
      <div className="specific-dates-options">
        <div className="container vacation-options">
          <div className="option-box">
            <div className="row center-md">
              <div className="sm-12 md-11 optionals-title">Select what applies to you (optional)</div>
            </div>
            <div className="row center-md">
              <div className="sm-12 md-11 optional-box">
                <div ref={this.ssgRef} className="optional-collapsible">

                  <VacationContext.Consumer>
                    {(context) => {
                      const user = context.state.ssgResponse.content || {};
                      const { fieldValidations, showRecaptcha } = context.state;
                      const {
                        firstName = '',
                        lastName = '',
                        ssgNumber = '',
                        points
                      } = user;
                      const {
                        username,
                        password,
                        recaptchaToken
                      } = fieldValidations;

                      const ssgCollapsed = this._getSSGCollapsibleState();

                      if (context.state.ssgResponse.code === 1) {
                        return (
                          <CollapsibleWrapper inputProps={ssgCheckBoxProps} expanded={ssgCollapsed} classList={['bonus-points-wrap']}>
                            <div className="sm-12 util-no-padding">
                              {/*
                                <div className="row">
                                  <div className="bonus-points-promo">
                                    <span className="d-block bonus-points-title">Book today and get 5000 bonus points</span>
                                    ($125) instantly towards your booking. Restrictions Apply.
                                    <a className="privacy-link" onClick={e => context.openModal('pointsOffer', e)}>View Details</a>
                                  </div>
                                </div>
                                ---------
                                This code adds a white banner for and ssg promotion, I'll leave it here in case another promotion comes along.
                              */}
                              <div className="row ss-positive-response">
                                <p className="sm-12">Welcome back, {`${firstName} ${lastName}`} | Member ID: {ssgNumber}</p>
                                <p className="sm-12 big">Available Points: {numberWithCommas(points)}. Valid for a discount of ${this._calculatePoints(points)}</p>
                                <button className="sm-8 sm-offset-2 md-4 md-offset-4 btn-hollow blue" onClick={context.logoutSSG}>Sign out</button>
                                <small className="sm-12 md-6 md-offset-3">Discount will be applied at the payment section. <span className="break">Money amount shown in US Dollars.</span></small>
                              </div>
                            </div>
                          </CollapsibleWrapper>
                        );
                      }

                      return (
                        <CollapsibleWrapper
                          expanded={ssgCollapsed}
                          inputProps={{ ...ssgCheckBoxProps, value: this.state.ssg }}
                          onToggle={this._handleSSG(context)}
                          onClose={context.clearSSGState}
                          classList={['bonus-points-wrap']}
                        >

                          <div className="row login-form-ss util-pr">
                            { /*
                              <div className="bonus-points-promo">
                                <span className="d-block bonus-points-title">Book today and get 5000 bonus points</span>
                                ($125) instantly towards your booking. Restrictions Apply.
                                <a className="privacy-link" onClick={e => context.openModal('pointsOffer', e)}>View Details</a>
                              </div>
                              ---------
                              This code adds a white banner for and ssg promotion, I'll leave it here in case another promotion comes along.
                            */}

                            <p className="sm-12 md-10 md-offset-1">Login to your Sandals Select Rewards account to be able to use your <span className="d-break">reward points for a discount at the payment section.</span></p>
                            {(!username || !password) && <p className="is-invalid sm-12 md-10 md-offset-1 lg-10 ssg-error">Field is required or invalid.</p>}
                            {(context.state.ssgResponse.code === 0) && <p className="is-invalid sm-12 md-offset-2 md-10 util-txt-center">Username or Password not valid. Please try again.</p>}

                            <div className="sm-12 md-5 md-offset-1 lg-4 lg-offset-1 push-down vacation-ssg-username">
                              <FormGroup
                                type="text"
                                name="username"
                                boxClassList={username ? ['full-width'] : ['is-invalid', 'full-width']}
                                onChange={(name, value) => context.setSSGState(value, name)}
                                value={context.state.ssgCredentials.username}
                                attrs={{ placeholder: 'Username', 'maxLength': 50 }}
                                icon={['icon-user']}
                              />
                              <button className="util-pointer util-txt-left forgot" onClick={() => context.openModal('forgotPassword', 'username')}><i className="icon-bold-arrow" /> Forgot username</button>
                            </div>

                            <div className=" sm-12 md-5 lg-4 vacation-ssg-password">
                              <FormGroup
                                type="password"
                                name="password"
                                boxClassList={password ? ['full-width'] : ['is-invalid', 'full-width']}
                                onChange={(name, value) => context.setSSGState(value, name)}
                                value={context.state.ssgCredentials.password}
                                attrs={{ placeholder: 'Password', 'maxLength': 16 }}
                                icon={['icon-password']}
                              />
                              <button className="util-pointer util-txt-left forgot" onClick={() => context.openModal('forgotPassword', 'password')}><i className="icon-bold-arrow" /> Forgot password</button>
                            </div>

                            <div className="sm-12 lg-2">
                              <button className="btn-primary bold optional-controls-btn" onClick={context.submitSSG}>LOGIN</button>
                            </div>

                            {showRecaptcha &&
                              <div className="recaptcha-wrapper">
                                <ReCAPTCHA
                                  ref={context.recaptchaRef}
                                  className="g-recaptcha"
                                  name="recaptchaToken"
                                  sitekey="6LfZYJUUAAAAAC4Kdfy2d4_XwIsODmNnao_zVCc5"
                                  onChange={(value) => context.setSSGState('recaptchaToken', value)}
                                />
                              </div>
                            }

                            {(!recaptchaToken) && <p className="is-invalid sm-12 md-10 md-offset-1 lg-10 lg-offset-2 recaptcha-error">Field is required.</p>}

                          </div>
                        </CollapsibleWrapper>
                      );
                    }}
                  </VacationContext.Consumer>

                </div>
              </div>
            </div>
            <div className="row center-md">
              <div className="sm-12 md-11 optional-box">
                <div className="optional-collapsible">
                  <VacationContext.Consumer>
                    {(context) => {

                      const { fieldValidations } = context.state;
                      const {
                        fname,
                        email,
                        country,
                      } = fieldValidations;

                      return (
                        <CollapsibleWrapper inputProps={subscriberCheckBoxProps} onToggle={this._handleSubscribe({ context })} onClose={() => context.setMultipleInputValues(['', '', ''], ['email', 'fname', 'country'])} >
                          <div className="sm-12 md-10 md-offset-1">
                            <div className="row">
                              <div className="sm-12 md-6 center subscribe-controls">
                                <Input
                                  type="text"
                                  name="fname"
                                  classList={!fname ? ['is-invalid', 'sm-12', 'push-down'] : ['sm-12', 'push-down']}
                                  onChange={context.setInputValue}
                                  value={context.state.fields.fname}
                                  attrs={{ placeholder: 'First Name', maxLength: 50 }}
                                />
                                {!fname && <p className="is-invalid">Invalid value. Letters only.</p>}

                              </div>
                              <div className="sm-12 md-6 center subscribe-controls">
                                <Input
                                  type="email"
                                  name="email"
                                  classList={!email ? ['is-invalid', 'sm-12', 'push-down'] : ['sm-12', 'push-down']}
                                  onChange={context.setInputValue}
                                  value={context.state.fields.email}
                                  attrs={{ placeholder: 'Email Address', maxLength: 50 }}
                                />
                                {!email && <p className="is-invalid">Please enter a valid email address.</p>}

                              </div>
                              <div className="sm-12 md-6 subscribe-controls">
                                <Select
                                  name="country"
                                  classList={!country ? ['is-invalid', 'push-down'] : ['push-down']}
                                  onChange={context.setInputValue}
                                  value={context.state.fields.country}
                                  defaultText="Select a country..."
                                  options={
                                    [
                                      { label: 'USA', value: 'US' },
                                      { label: 'UK', value: 'GB' },
                                      { label: 'Canada', value: 'CA' },
                                      { label: 'Other', value: 'OT' }
                                    ]
                                  }
                                />
                                {!country && <p className="is-invalid">Invalid value or required field.</p>}
                              </div>
                            </div>
                            <div className="row subscribe-disclaimer">
                              {context.state.fields.country !== '' &&
                                <p className="sm-12">
                                  I want to receive promotional emails about {brand} Resorts from Unique Travel Corp.,
                                  the Worldwide Representative of {brand} Resorts, P.O. Box SS-19020, Nassau, Bahamas.
                                  You can contact us at <a href={`mailto:info@${brand.toLowerCase()}.com`}>info@{brand.toLowerCase()}.com</a>.
                                  You may unsubscribe at any time.
                                </p>
                              }
                              {/* SOBE-976: I know this will back, so I will leave it commented out, feel free to uncomment */}
                              {/* { context.state.fields.country === 'CA' &&
                                <p className="sm-12">
                                  I want to receive electronic communications such as promotions, special
                                  savings and event notifications about { brand } Resorts from Unique Travel Corp.,
                                  the Worldwide Representative of { brand } Resorts, P.O. Box SS-19020, Nassau, Bahamas.
                                  You can contact us at <a href="mailto:info@sandals.com">info@sandals.com</a>.
                                  You may unsubscribe at any time.
                                </p>
                              }
                              { context.state.fields.country !== 'CA' &&
                                <p className="sm-12">
                                  I want to receive electronic communications such as promotions,
                                  special savings and event notifications about { brand } Resorts.
                                </p>
                              } */}
                            </div>
                          </div>
                        </CollapsibleWrapper>
                      );
                    }}
                  </VacationContext.Consumer>
                </div>
              </div>
            </div>
          </div>

          <WhyBook brand={brand} />

          <div className="center-sm bottom-row row">

            {/* <div className="row sub-banner util-txt-center">
              <div className="sm-12">
                <div className="sub-banner-cont util-center">
                  <a href={`https:${brandURL}/book-with-confidence/`} className="visible-lg-up" target="_blank">
                    <img src={`${window._app.cdnPath}step1/vacation/vacation-assurance-banner-desktop.jpg`} className="util-img-responsive" alt="Travel Protection Plan"/>
                  </a>
                  <a href={`https:${brandURL}/book-with-confidence/`} className="visible-md-up hidden-lg-up" target="_blank">
                    <img src={`${window._app.cdnPath}step1/vacation/vacation-assurance-banner-tablet.jpg`} className="util-img-responsive" alt="Travel Protection Plan"/>
                  </a>
                  <a href={`https:${brandURL}/book-with-confidence/`} className="hidden-md-up" target="_blank">
                    <img src={`${window._app.cdnPath}step1/vacation/vacation-assurance-banner-mobile.jpg`} className="sub-banner-img util-img-responsive util-center" alt="Travel Protection Plan"/>
                  </a>
                </div>
              </div>
          </div> */}

            <VacationContext.Consumer>
              {(context) => (
                <Fragment>
                  <SubmitLoader isActive={context.state.showLoader} />
                  <ContinueButton
                    toggleLoader={context.toggleLoader}
                    fields={context.getFields}
                    guestInfo={context.getGuestInfo}
                    contextState={context.state}
                    updateGuests={context.updateGuestInfo}
                    setVacationResponse={context.setVacationResponse}
                    cleanVacationResponse={context.cleanVacationResponse}
                    submitVacation={context.submitVacation} />
                  <div className="row sm-12 center-sm">
                    <a className="best-price-guarantee util-txt-center" onClick={e => context.openModal('bestPrice', e)}>
                      Best price guarantee <i className="icon-paragraph" />
                    </a>
                  </div>
                  <BestPriceModalWrapper context={context} />
                  <ForgotPasswordModalWrapper brand={brand} context={context} />
                </Fragment>
              )}
            </VacationContext.Consumer>
          </div>
          <PrivacyPolicyModalWrapper brand={brand} />
          <PointsOfferModalWrapper brand={brand} />
        </div>
      </div>
    );
  }
}

export default OptionalControls;



// WEBPACK FOOTER //
// ./js/views/step1/OptionalControls.js